import {Component, OnInit} from '@angular/core';
import {WidgetInputDirective} from '../directives/widget-input.directive';
import {Store} from '@ngrx/store';
import * as NgrxWidgetActions from '../store/actions/widget.actions';
import {StoreWidgetState} from '@pt/pt-models';
import {WidgetStatus} from '../widget-status';

@Component({
  selector: 'pt-widget-not-supported',
  template: `
    <p>Widget: {{initializationWidget.type}} [id = {{initializationWidget.internalId}}]
      <b><span>not supported!</span></b>
    </p>
  `
})
export class WidgetNotSupportedComponent extends WidgetInputDirective implements OnInit {
  constructor(private store: Store) {
    super();
  }

  ngOnInit(): void {
    this.store.dispatch(NgrxWidgetActions.setWidgetState(
      {
        widgetStatus: {
          internalId: this.initializationWidget?.internalId,
          version: this.initializationWidget?.version,
          type: this.initializationWidget.type,
          state: StoreWidgetState.COMPLETED,
          valid: false,
          activeEditMode: false
        } as WidgetStatus
      }));
  }
}
